import { render } from "./RecursiveDrugsMenu.vue?vue&type=template&id=e207dd66"
import script from "./RecursiveDrugsMenu.vue?vue&type=script&lang=js"
export * from "./RecursiveDrugsMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__